import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal } from 'synfrastructure';
import Pagination from 'rc-pagination';
import USLocale from 'rc-pagination/lib/locale/en_US';

import FollowUpList from '../common/FollowUpList';
import { getFollowUpData, getTathataFollowUps } from '../redux/actions';
import { selectHistorySessions } from '../redux/selectors';
import Loading from '../../common/components/Loading';
import Icon from '../../common/icons/Icon';
import HistoryViewModal from './HistoryViewModal';

class FollowUpsHistory extends Component {
  state = {
    viewItemModal: false,
    modalActiveSession: null,
    page: 1,
    pageSize: 10,
  };

  componentDidMount = () => {
    this.props.dispatch(getFollowUpData());
    this.props.dispatch(getTathataFollowUps());
  };

  setPage = page => {
    this.setState({ page });
  };

  getSessionPage = () => {
    const { followUpHistory } = this.props;
    const { page, pageSize } = this.state;

    // Should slice to the end of the array if there aren't enough records left.
    const beginningIndex = (page - 1) * pageSize;
    if (followUpHistory.length < page * pageSize) {
      return followUpHistory.slice(beginningIndex);
    } else {
      return followUpHistory.slice(beginningIndex, beginningIndex + pageSize);
    }
  };

  toggleViewModal = session => {
    this.setState(state => ({
      modalActiveSession: session,
      viewItemModal: !state.viewItemModal,
    }));
  };

  render = () => {
    const { followUpHistory, loaded } = this.props;
    const { viewItemModal, modalActiveSession, pageSize } = this.state;

    if (!loaded) {
      return <Loading />;
    }

    const sessionPage = this.getSessionPage();

    return (
      <div>
        {viewItemModal && (
          <Modal
            isVisible
            onClose={this.toggleViewModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <HistoryViewModal session={modalActiveSession} toggleModal={this.toggleViewModal} />
          </Modal>
        )}
        <div className="follow-up--history__container">
          <Link className="back-to" to={'/follow-ups'}>
            <span className="button__back-button">
              <Icon icon="BackArrow" />Back to Follow-Ups
            </span>
          </Link>
          <h3 className="follow-up--history-header">Follow-Ups History</h3>
          <div className="history-container">
            <FollowUpList
              headerTitle="History"
              icon="Envelope"
              onItemView={this.toggleViewModal}
              sessions={sessionPage || []}
              type="history"
            />
            {followUpHistory.length > pageSize && (
              <Pagination
                onChange={this.setPage}
                current={this.state.page}
                pageSize={this.state.pageSize}
                total={followUpHistory.length}
                locale={USLocale}
              />
            )}
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state, props) => {
  return {
    followUpHistory: selectHistorySessions(state),
    loaded: state.followUps.followUps.get('loaded') && state.followUps.followUpData.get('loaded'),
  };
};

export default connect(mapStateToProps)(FollowUpsHistory);



// WEBPACK FOOTER //
// ./src/follow-ups/history/FollowUpsHistory.js